const loadImage = async (url: string) =>
  new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      image.onload = null;
      resolve(image);
    };
    image.onerror = reject;
    image.src = url;
  });

export default loadImage;
